export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const FACTORY_LIST = 'FACTORY_LIST';
export const LINE_LIST = 'LINE_LIST';
export const COMM_CODE = 'COMM_CODE';

export const IMAGE_FILE = 'IMAGE_FILE'; // 이미지 파일관련

export default {
	STATE_INIT,
	DEFAULT_ASSIGN,
	COMM_CODE,
	FACTORY_LIST,
	LINE_LIST,
	IMAGE_FILE
};
